import $ from 'jquery';
import { event } from '../compat/core';
import localizeResx from '../helpers/localize-resx';
import renderIcon from './pointShapeIconRenderer';

const selectionTemplates = {
  gisLayer: renderGisLayerSelectionTemplate,
  shape: renderShapeSelectionTemplate,
  localizeResx: localizeResxTemplate
};
const resultTemplates = {
  gisLayer: renderGisLayerResultTemplate,
  shape: renderShapeResultTemplate,
  localizeResx: localizeResxTemplate
};

export default function () {
  // odata result rendering
  event.off('linksoft.select2.renderingTemplate', renderResult);
  event.on('linksoft.select2.renderingTemplate', renderResult);

  // selected item rendering
  event.off('linksoft.select2.renderingTemplateSelection', renderSelection);
  event.on('linksoft.select2.renderingTemplateSelection', renderSelection);

  // trigger this event to force render of the selection (this way the preselected item is updated with the custom template)
  $('select[data-custom-template]').trigger('change');
}

function renderSelection(params) {
  const customTemplate = $(params.item).attr('data-custom-template');

  if (customTemplate && selectionTemplates[customTemplate]) {
    params.result = selectionTemplates[customTemplate](params);
  }
}

function renderResult(params) {
  const customTemplate = $(params.item).attr('data-custom-template');

  if (customTemplate && resultTemplates[customTemplate]) {
    params.result = resultTemplates[customTemplate](params);
  }
}

/* xxx*/
function localizeResxTemplate(params) {
  return localizeResx(params.data.text);
}

/* begin gis layer */
function renderGisLayerSelectionTemplate(params) {
  // if the value is preselected at page load, its additional information (=color) is stored in the parent select in data-initial-value attribute
  const selectionColor = params.data.text2 || $(params.item).attr('data-initial-value');
  if (selectionColor && params.data.id !== '') {
    return renderGisLayer(selectionColor, params.data.text);
  }
  return params.result;
}

function renderGisLayerResultTemplate(params) {
  if (params.data.text2) {
    return renderGisLayer(params.data.text2, params.data.text);
  }
  return params.result;
}

function renderGisLayer(color, text) {
  return `<span class='gis-layer-box' style='background-color:${color}'></span><span>${text}</span>`;
}
/* end gis layer */

/* begin (nominal point) shape */
function renderShapeSelectionTemplate(params) {
  if (params.data.id !== '') {
    return renderShape(params.data.id, params.data.text);
  }
  return params.result;
}

function renderShapeResultTemplate(params) {
  if (params.data.id !== '') {
    return renderShape(params.data.id, params.data.text);
  }
  return params.result;
}

function renderShape(shapeId, text) {
  // return `<span class='nominal-point-shape nominal-point-shape-${shapeId}'>${text}</span>`;
  return `<span class='nominal-point-shape'>
            ${renderIcon(+shapeId)}
            ${text}
         </span>`;
}
/* end shape */
